import { store } from "../../../applicationState";
import { makeToHeaderProps } from "./makeToHeaderProps";

export * from "./toFooterProps";
export const toHeaderProps = makeToHeaderProps(store.dispatch);
